import { getClubInformation } from '../../src/content/club-look-ups-by-id';
import { clubDataRepository } from '../../src/content/constants';
import { getClubDefaultLanguage } from '../../src/helpers/language-helper';

export type ClubMetadata = {
  clubId: string;
  clubName: string;
  clubUrlName: string;
  clubDataRepository: string;
};

export const getClubMetadata = (siteId: string): ClubMetadata => {
  const clubInformation = getClubInformation(siteId);
  return {
    clubId: clubInformation.siteId,
    clubName: clubInformation.clubName,
    clubUrlName: clubInformation.hyphenatedClubName,
    clubDataRepository: clubDataRepository(
      clubInformation.siteId,
      getClubDefaultLanguage(clubInformation.siteId)
    ),
  };
};
